import styled from "styled-components";
import {media, tokens} from "../../../../theme";

export const TextTranslatorCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    
    overflow: hidden;
    
    border-radius: ${tokens.radius['4xl']};
    background-color: ${({theme}) => theme.palette.background.paper};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};
`;

export const TextTranslatorCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 24px;
    width: 100%;
    height: 100%;
    flex: 1;
    
    border: 1px none ${({theme}) => theme.palette.dividers.subtle};
    border-bottom-style: solid;

    ${media.tablet} {
        justify-content: flex-start;
    }

`;

export const TextTranslatorCardHeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    letter-spacing: ${tokens.letterSpacing.button};
    gap: 12px;

    ${media.tablet} {
        flex-direction: row;
        align-items: center;
        justify-content: left;

        gap: 36px;
    }
`;

export const TextTranslatorCardHeaderActionButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    
    gap: 12px;
`;

export const TextTranslatorCardMain = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    flex: 9;
`;
export const TextTranslatorCardMainContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;
export const TextTranslatorCardMainSourceTextareaContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;
export const TextTranslatorCardMainSourceTextarea = styled.textarea`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    flex: 11;
    padding: 20px;

    background-color: inherit;
    resize: none;
    border: none;
    
    &:focus {
        outline: none;
    }
`;
export const TextTranslatorCardMainSourceFooter = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    flex: 1;

    border: 1px none ${({theme}) => theme.palette.dividers.subtle};
    border-top-style: solid;
`;

export const TextTranslatorCardMainSourceFooterCharacterCounter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px;
    font-size: ${tokens.fontSize.xs};
    color: ${({theme}) => theme.palette.text.hint};
`;

export const TextTranslatorCardMainSeparator = styled.hr`
    display: flex;
    margin: 0;
    height: 100%;
    border: none;
    width: 1px;
    background-color: ${({theme}) => theme.palette.dividers.subtle};
`;
export const TextTranslatorCardMainTargetTextareaContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    
    background-color: ${({theme}) => theme.palette.background.dropzone};
`;
export const TextTranslatorCardMainTargetTextarea = styled.textarea`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    flex: 11;
    padding: 20px;

    background-color: inherit;
    resize: none;
    border: none;
    
    &:focus {
        outline: none;
    }
`;
export const TextTranslatorCardMainTargetFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    flex: 1;

    background-color: inherit;
    border: 1px none ${({theme}) => theme.palette.dividers.subtle};
    border-top-style: solid;
`;
